/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { PublishStatus } from './publishStatus'
import type { ScenarioDisplayType } from './scenarioDisplayType'

export interface Scenario {
  /**
   * プレイリスト共通CTA 文言
   * @nullable
   */
  ctaLabel: string | null
  /**
   * プレイリスト共通CTA URL（SLIDER/TILE限定・動画CTA未設定時の既定値・ADR-0019）
   * @nullable
   */
  ctaUrl: string | null
  /** @nullable */
  popupThumbnailMimeType: string | null
  /** @nullable */
  popupThumbnailS3Key: string | null
  /** @nullable */
  publishedAt: string | null
  updatedAt: string
  createdAt: string
  version: number
  publishStatus: PublishStatus
  config: unknown
  displayType: ScenarioDisplayType
  initialNodeKey: string
  /** @nullable */
  description: string | null
  name: string
  tenantId: Cuid
  id: Cuid
}
